import React from "react";
import { MessageCircle } from "lucide-react";
import { SITE, FAQS } from "@/data/site";
import { Gonjong } from "@/components/Gonjong";

const Faq = () => (
  <main data-testid="faq-page">
    <section className="relative bg-ink text-rice">
      <div className="mx-auto max-w-6xl px-4 pb-20 pt-16 sm:px-6 sm:pt-20">
        <p className="text-sm font-bold uppercase tracking-[0.22em] text-kunyit">
          FAQ
        </p>
        <h1
          data-testid="faq-h1"
          className="mt-3 max-w-2xl font-display text-4xl font-black leading-tight sm:text-5xl"
        >
          Pertanyaan yang sering ditanyakan
        </h1>
      </div>
      <div className="absolute bottom-0 left-0 right-0 text-rice">
        <Gonjong />
      </div>
    </section>

    <section className="mx-auto max-w-4xl px-4 py-16 sm:px-6 sm:py-20">
      <div className="space-y-4" data-testid="faq-list">
        {FAQS.map((f, i) => (
          <details
            key={f.q}
            data-testid={`faq-item-${i}`}
            className="group rounded-2xl border border-ink/10 bg-card open:border-lado/40"
          >
            <summary className="flex cursor-pointer list-none items-center justify-between gap-4 p-6 font-display text-lg font-bold text-ink [&::-webkit-details-marker]:hidden">
              {f.q}
              <span
                aria-hidden="true"
                className="shrink-0 font-body text-2xl font-bold text-lado transition-transform group-open:rotate-45"
              >
                +
              </span>
            </summary>
            <p className="px-6 pb-6 text-sm leading-relaxed text-ink/75 sm:text-base">
              {f.a}
            </p>
          </details>
        ))}
      </div>

      <div className="mt-12 rounded-2xl bg-ijo p-8 text-center text-rice sm:p-10">
        <h2 className="font-display text-2xl font-bold">Masih ada pertanyaan?</h2>
        <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-rice/85 sm:text-base">
          Tim kami siap membantu melalui WhatsApp resmi {SITE.name}.
        </p>
        <a
          href={SITE.wa.href}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="faq-wa-cta"
          className="mt-6 inline-flex items-center gap-2 rounded-full bg-rice px-7 py-3.5 text-base font-bold text-ijo transition-transform hover:-translate-y-0.5"
        >
          <MessageCircle className="h-5 w-5" aria-hidden="true" />
          Hubungi Kami
        </a>
      </div>
    </section>
  </main>
);

export default Faq;
